import Drawer from 'Components/Drawer';
import Panel from 'Components/Panel';
import Table from 'Components/SimpleTable';
import { sortBy } from 'lodash';
import NewDevice from 'Pages/Tree/Device/New';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectRootDevices } from 'selectors/devices';
import { selectSiteInstallationZones } from 'selectors/sites.js';
import { unixToDate } from 'utils/date';
import icons from 'utils/ui/icons';
import UploadBridgeDevices from './UploadBridgeDevices';
import UploadDevices from './UploadDevices';
import UploadDigitalDevices from './UploadDigitalDevices';

const rootDeviceProperties = [
    { label: 'Name', dataKey: 'name' },
    { label: 'Last Update', dataKey: 'updated_at', transform: model => `${model.updater_name} @ ${unixToDate(model.updated_at)}` }
];

const Component = props => {
    const { siteId } = props;

    const [drawer, setOpenDrawer] = useState(null);
    const closeDrawer = () => setOpenDrawer(null);

    const selectedRootDevices = useMemo(() => selectRootDevices(siteId), [siteId]);
    const rootDevices = useSelector(selectedRootDevices);
    const selectedSiteInstallationZones = useMemo(() => selectSiteInstallationZones(siteId), [siteId]);
    const installationZones = useSelector(selectedSiteInstallationZones);

    const buttons = [
        { icon: icons.addEntity, onClick: () => setOpenDrawer('newDevice'), tooltip: 'New child device' },
        { icon: icons.upload, onClick: () => setOpenDrawer('uploadDevices'), tooltip: 'Upload devices file' },
        { icon: icons.fileImport, onClick: () => setOpenDrawer('uploadBridgeDevices'), tooltip: 'Upload bridge devices file' },
        { icon: icons.fileUpload, onClick: () => setOpenDrawer('uploadDigitalDevices'), tooltip: 'Upload digital devices file' }
    ];

    let DrawerContent;
    if (drawer === 'newDevice') {
        DrawerContent = (
            <NewDevice installationZones={installationZones} onSave={closeDrawer} parentDeviceId={null} siteId={siteId}/>
        );
    } else if (drawer === 'uploadDevices') {
        DrawerContent = (
            <UploadDevices siteId={siteId}/>
        );
    } else if (drawer === 'uploadBridgeDevices') {
        DrawerContent = (
            <UploadBridgeDevices siteId={siteId}/>
        );
    } else if (drawer === 'uploadDigitalDevices') {
        DrawerContent = (
            <UploadDigitalDevices siteId={siteId}/>
        );
    }

    return (
        <React.Fragment>
            <Panel buttons={buttons}>
                <Table columns={rootDeviceProperties} rows={sortBy(rootDevices, 'name')}/>
            </Panel>
            <Drawer onClose={closeDrawer} open={!!drawer}>
                {DrawerContent}
            </Drawer>
        </React.Fragment>
    );
};

export default Component;
